import { Handle } from '../Canvas';
import { WorkflowBox } from '../WorkflowBox/WorkflowBox';

export const DropzoneNodeWorkflowId = 'DropzoneNodeWorkflow';

export const DropNode = () => {
  return (
    <>
      <Handle type="target" position={'top' as any} />
      <WorkflowBox
        variant={'Default'}
        style={{ height: '196px', border: '2px dashed  #586874' }}
        id={DropzoneNodeWorkflowId}
        ariaLabel="Dropzone workflow"
      ></WorkflowBox>
      <Handle type="source" position={'bottom' as any} />
    </>
  );
};
